import { createUseStyles } from 'react-jss'
import { WHITE } from '@styles/colors'

export default createUseStyles({
  header: {
    fontSize: '24px',
    fontWeight: 'bold',
    lineHeight: '35px'
  },
  iconContainer: {
    display: 'flex',
    justifyContent: 'center'
  },
  modalTextContainer: {
    '& > div': {
      color: WHITE,
      fontSize: '22px',
      marginBottom: '10px',
      padding: '5px'
    },
    '& div:not(:nth-child(1))': {
      fontSize: '18px'
    },
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    margin: '30px 0',
    textAlign: 'center'
  }
})
